import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4d9971da = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _6d1959ae = () => interopDefault(import('../pages/appmalf-sdk/index.vue' /* webpackChunkName: "pages/appmalf-sdk/index" */))
const _4137e15b = () => interopDefault(import('../pages/apps/index.vue' /* webpackChunkName: "pages/apps/index" */))
const _2049bf3e = () => interopDefault(import('../pages/authentication/index.vue' /* webpackChunkName: "pages/authentication/index" */))
const _b51b2fa6 = () => interopDefault(import('../pages/cli/index.vue' /* webpackChunkName: "pages/cli/index" */))
const _562ec170 = () => interopDefault(import('../pages/combo-sdk/index.vue' /* webpackChunkName: "pages/combo-sdk/index" */))
const _3d623fbe = () => interopDefault(import('../pages/commitment/index.vue' /* webpackChunkName: "pages/commitment/index" */))
const _9455d578 = () => interopDefault(import('../pages/compliance/index.vue' /* webpackChunkName: "pages/compliance/index" */))
const _0169f3df = () => interopDefault(import('../pages/consulting/index.vue' /* webpackChunkName: "pages/consulting/index" */))
const _555b57cc = () => interopDefault(import('../pages/custom/index.vue' /* webpackChunkName: "pages/custom/index" */))
const _d8543eda = () => interopDefault(import('../pages/data/index.vue' /* webpackChunkName: "pages/data/index" */))
const _0db0e40f = () => interopDefault(import('../pages/deleteAccount/index.vue' /* webpackChunkName: "pages/deleteAccount/index" */))
const _9c9eaef4 = () => interopDefault(import('../pages/edge-security-acceleration/index.vue' /* webpackChunkName: "pages/edge-security-acceleration/index" */))
const _0086b52a = () => interopDefault(import('../pages/feedback.vue' /* webpackChunkName: "pages/feedback" */))
const _6d7360f0 = () => interopDefault(import('../pages/game-sdk/index.vue' /* webpackChunkName: "pages/game-sdk/index" */))
const _1987efe5 = () => interopDefault(import('../pages/game-sim/index.vue' /* webpackChunkName: "pages/game-sim/index" */))
const _51326f6a = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _1854b2af = () => interopDefault(import('../pages/high-bandwidth/index.vue' /* webpackChunkName: "pages/high-bandwidth/index" */))
const _bf85c182 = () => interopDefault(import('../pages/infoDownload/index.vue' /* webpackChunkName: "pages/infoDownload/index" */))
const _7c8ea98e = () => interopDefault(import('../pages/information/index.vue' /* webpackChunkName: "pages/information/index" */))
const _55de79d8 = () => interopDefault(import('../pages/inquiry/index.vue' /* webpackChunkName: "pages/inquiry/index" */))
const _bb34dbb0 = () => interopDefault(import('../pages/intranet/index.vue' /* webpackChunkName: "pages/intranet/index" */))
const _00006928 = () => interopDefault(import('../pages/management/index.vue' /* webpackChunkName: "pages/management/index" */))
const _06fa574e = () => interopDefault(import('../pages/mobile-network-sdk/index.vue' /* webpackChunkName: "pages/mobile-network-sdk/index" */))
const _1299e5f4 = () => interopDefault(import('../pages/net-sim/index.vue' /* webpackChunkName: "pages/net-sim/index" */))
const _7c99f17c = () => interopDefault(import('../pages/network-equipment/index.vue' /* webpackChunkName: "pages/network-equipment/index" */))
const _0660c3fe = () => interopDefault(import('../pages/nodes/index.vue' /* webpackChunkName: "pages/nodes/index" */))
const _126fd5aa = () => interopDefault(import('../pages/packet-capture/index.vue' /* webpackChunkName: "pages/packet-capture/index" */))
const _2ed2ed5c = () => interopDefault(import('../pages/plugin/index.vue' /* webpackChunkName: "pages/plugin/index" */))
const _890240d6 = () => interopDefault(import('../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _37678acd = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _3947d982 = () => interopDefault(import('../pages/quality-monitoring/index.vue' /* webpackChunkName: "pages/quality-monitoring/index" */))
const _472ad241 = () => interopDefault(import('../pages/realtime-sdk/index.vue' /* webpackChunkName: "pages/realtime-sdk/index" */))
const _f872c60c = () => interopDefault(import('../pages/record/index.vue' /* webpackChunkName: "pages/record/index" */))
const _f23c5d84 = () => interopDefault(import('../pages/satisfaction-improvement/index.vue' /* webpackChunkName: "pages/satisfaction-improvement/index" */))
const _91795a68 = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _42852ce0 = () => interopDefault(import('../pages/smpro/index.vue' /* webpackChunkName: "pages/smpro/index" */))
const _003580b4 = () => interopDefault(import('../pages/speedtest/index.vue' /* webpackChunkName: "pages/speedtest/index" */))
const _71556c3c = () => interopDefault(import('../pages/speedtest-deployment/index.vue' /* webpackChunkName: "pages/speedtest-deployment/index" */))
const _4773aed3 = () => interopDefault(import('../pages/speedtest-sdk/index.vue' /* webpackChunkName: "pages/speedtest-sdk/index" */))
const _d0da3158 = () => interopDefault(import('../pages/terms/index.vue' /* webpackChunkName: "pages/terms/index" */))
const _615663b8 = () => interopDefault(import('../pages/testing-services/index.vue' /* webpackChunkName: "pages/testing-services/index" */))
const _4bdf5f75 = () => interopDefault(import('../pages/video-sdk/index.vue' /* webpackChunkName: "pages/video-sdk/index" */))
const _57a9985a = () => interopDefault(import('../pages/vote/index.vue' /* webpackChunkName: "pages/vote/index" */))
const _57039c1a = () => interopDefault(import('../pages/web-open-speed-sdk/index.vue' /* webpackChunkName: "pages/web-open-speed-sdk/index" */))
const _27a1ffa7 = () => interopDefault(import('../pages/whole-home-wifi-sdk/index.vue' /* webpackChunkName: "pages/whole-home-wifi-sdk/index" */))
const _395c7064 = () => interopDefault(import('../pages/wifi-analysis-sdk/index.vue' /* webpackChunkName: "pages/wifi-analysis-sdk/index" */))
const _3e7f17a4 = () => interopDefault(import('../pages/wifiDetector/index.vue' /* webpackChunkName: "pages/wifiDetector/index" */))
const _bad60030 = () => interopDefault(import('../pages/deleteAccount/recovery.vue' /* webpackChunkName: "pages/deleteAccount/recovery" */))
const _cf149be8 = () => interopDefault(import('../pages/deleteAccount/request.vue' /* webpackChunkName: "pages/deleteAccount/request" */))
const _e568a6f6 = () => interopDefault(import('../pages/deleteAccount/status.vue' /* webpackChunkName: "pages/deleteAccount/status" */))
const _90a2bb78 = () => interopDefault(import('../pages/deleteAccount/terms.vue' /* webpackChunkName: "pages/deleteAccount/terms" */))
const _4edcbfe7 = () => interopDefault(import('../pages/help/support.vue' /* webpackChunkName: "pages/help/support" */))
const _004cff1e = () => interopDefault(import('../pages/products/cli/index.vue' /* webpackChunkName: "pages/products/cli/index" */))
const _b345e9c4 = () => interopDefault(import('../pages/products/high-bandwidth/index.vue' /* webpackChunkName: "pages/products/high-bandwidth/index" */))
const _dc0eac52 = () => interopDefault(import('../pages/products/intranet/index.vue' /* webpackChunkName: "pages/products/intranet/index" */))
const _1b53b66a = () => interopDefault(import('../pages/products/plugin/index.vue' /* webpackChunkName: "pages/products/plugin/index" */))
const _568cbc90 = () => interopDefault(import('../pages/products/sdk/index.vue' /* webpackChunkName: "pages/products/sdk/index" */))
const _3f8fdd4d = () => interopDefault(import('../pages/products/speedtest-package.vue' /* webpackChunkName: "pages/products/speedtest-package" */))
const _495d533b = () => interopDefault(import('../pages/products/speedtest-package-overcount.vue' /* webpackChunkName: "pages/products/speedtest-package-overcount" */))
const _2e43fe17 = () => interopDefault(import('../pages/smpro/payment/index.vue' /* webpackChunkName: "pages/smpro/payment/index" */))
const _20e37ea1 = () => interopDefault(import('../pages/wwzs/enterprise.vue' /* webpackChunkName: "pages/wwzs/enterprise" */))
const _0ee9be11 = () => interopDefault(import('../pages/products/cli/data/index.vue' /* webpackChunkName: "pages/products/cli/data/index" */))
const _d0d81602 = () => interopDefault(import('../pages/products/cli/document.vue' /* webpackChunkName: "pages/products/cli/document" */))
const _317e6dec = () => interopDefault(import('../pages/products/cli/download.vue' /* webpackChunkName: "pages/products/cli/download" */))
const _2d013211 = () => interopDefault(import('../pages/products/high-bandwidth/data/index.vue' /* webpackChunkName: "pages/products/high-bandwidth/data/index" */))
const _7cf868ff = () => interopDefault(import('../pages/products/high-bandwidth/document.vue' /* webpackChunkName: "pages/products/high-bandwidth/document" */))
const _6fa423a6 = () => interopDefault(import('../pages/products/intranet/document.vue' /* webpackChunkName: "pages/products/intranet/document" */))
const _45061c84 = () => interopDefault(import('../pages/products/plugin/data/index.vue' /* webpackChunkName: "pages/products/plugin/data/index" */))
const _e3e9579c = () => interopDefault(import('../pages/products/plugin/document.vue' /* webpackChunkName: "pages/products/plugin/document" */))
const _d446a892 = () => interopDefault(import('../pages/products/sdk/data/index.vue' /* webpackChunkName: "pages/products/sdk/data/index" */))
const _b4dbd7b6 = () => interopDefault(import('../pages/products/sdk/document.vue' /* webpackChunkName: "pages/products/sdk/document" */))
const _3f7c8d12 = () => interopDefault(import('../pages/products/sdk/download.vue' /* webpackChunkName: "pages/products/sdk/download" */))
const _5084dd88 = () => interopDefault(import('../pages/smpro/payment/success.vue' /* webpackChunkName: "pages/smpro/payment/success" */))
const _b7a133ce = () => interopDefault(import('../pages/products/cli/data/download.vue' /* webpackChunkName: "pages/products/cli/data/download" */))
const _6f737219 = () => interopDefault(import('../pages/products/high-bandwidth/data/download.vue' /* webpackChunkName: "pages/products/high-bandwidth/data/download" */))
const _d8fae274 = () => interopDefault(import('../pages/products/plugin/data/download.vue' /* webpackChunkName: "pages/products/plugin/data/download" */))
const _67f6629a = () => interopDefault(import('../pages/products/sdk/data/download.vue' /* webpackChunkName: "pages/products/sdk/data/download" */))
const _79dc5948 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _4d9971da,
    name: "about"
  }, {
    path: "/appmalf-sdk",
    component: _6d1959ae,
    name: "appmalf-sdk"
  }, {
    path: "/apps",
    component: _4137e15b,
    name: "apps"
  }, {
    path: "/authentication",
    component: _2049bf3e,
    name: "authentication"
  }, {
    path: "/cli",
    component: _b51b2fa6,
    name: "cli"
  }, {
    path: "/combo-sdk",
    component: _562ec170,
    name: "combo-sdk"
  }, {
    path: "/commitment",
    component: _3d623fbe,
    name: "commitment"
  }, {
    path: "/compliance",
    component: _9455d578,
    name: "compliance"
  }, {
    path: "/consulting",
    component: _0169f3df,
    name: "consulting"
  }, {
    path: "/custom",
    component: _555b57cc,
    name: "custom"
  }, {
    path: "/data",
    component: _d8543eda,
    name: "data"
  }, {
    path: "/deleteAccount",
    component: _0db0e40f,
    name: "deleteAccount"
  }, {
    path: "/edge-security-acceleration",
    component: _9c9eaef4,
    name: "edge-security-acceleration"
  }, {
    path: "/feedback",
    component: _0086b52a,
    name: "feedback"
  }, {
    path: "/game-sdk",
    component: _6d7360f0,
    name: "game-sdk"
  }, {
    path: "/game-sim",
    component: _1987efe5,
    name: "game-sim"
  }, {
    path: "/help",
    component: _51326f6a,
    name: "help"
  }, {
    path: "/high-bandwidth",
    component: _1854b2af,
    name: "high-bandwidth"
  }, {
    path: "/infoDownload",
    component: _bf85c182,
    name: "infoDownload"
  }, {
    path: "/information",
    component: _7c8ea98e,
    name: "information"
  }, {
    path: "/inquiry",
    component: _55de79d8,
    name: "inquiry"
  }, {
    path: "/intranet",
    component: _bb34dbb0,
    name: "intranet"
  }, {
    path: "/management",
    component: _00006928,
    name: "management"
  }, {
    path: "/mobile-network-sdk",
    component: _06fa574e,
    name: "mobile-network-sdk"
  }, {
    path: "/net-sim",
    component: _1299e5f4,
    name: "net-sim"
  }, {
    path: "/network-equipment",
    component: _7c99f17c,
    name: "network-equipment"
  }, {
    path: "/nodes",
    component: _0660c3fe,
    name: "nodes"
  }, {
    path: "/packet-capture",
    component: _126fd5aa,
    name: "packet-capture"
  }, {
    path: "/plugin",
    component: _2ed2ed5c,
    name: "plugin"
  }, {
    path: "/privacy",
    component: _890240d6,
    name: "privacy"
  }, {
    path: "/products",
    component: _37678acd,
    name: "products"
  }, {
    path: "/quality-monitoring",
    component: _3947d982,
    name: "quality-monitoring"
  }, {
    path: "/realtime-sdk",
    component: _472ad241,
    name: "realtime-sdk"
  }, {
    path: "/record",
    component: _f872c60c,
    name: "record"
  }, {
    path: "/satisfaction-improvement",
    component: _f23c5d84,
    name: "satisfaction-improvement"
  }, {
    path: "/settings",
    component: _91795a68,
    name: "settings"
  }, {
    path: "/smpro",
    component: _42852ce0,
    name: "smpro"
  }, {
    path: "/speedtest",
    component: _003580b4,
    name: "speedtest"
  }, {
    path: "/speedtest-deployment",
    component: _71556c3c,
    name: "speedtest-deployment"
  }, {
    path: "/speedtest-sdk",
    component: _4773aed3,
    name: "speedtest-sdk"
  }, {
    path: "/terms",
    component: _d0da3158,
    name: "terms"
  }, {
    path: "/testing-services",
    component: _615663b8,
    name: "testing-services"
  }, {
    path: "/video-sdk",
    component: _4bdf5f75,
    name: "video-sdk"
  }, {
    path: "/vote",
    component: _57a9985a,
    name: "vote"
  }, {
    path: "/web-open-speed-sdk",
    component: _57039c1a,
    name: "web-open-speed-sdk"
  }, {
    path: "/whole-home-wifi-sdk",
    component: _27a1ffa7,
    name: "whole-home-wifi-sdk"
  }, {
    path: "/wifi-analysis-sdk",
    component: _395c7064,
    name: "wifi-analysis-sdk"
  }, {
    path: "/wifiDetector",
    component: _3e7f17a4,
    name: "wifiDetector"
  }, {
    path: "/deleteAccount/recovery",
    component: _bad60030,
    name: "deleteAccount-recovery"
  }, {
    path: "/deleteAccount/request",
    component: _cf149be8,
    name: "deleteAccount-request"
  }, {
    path: "/deleteAccount/status",
    component: _e568a6f6,
    name: "deleteAccount-status"
  }, {
    path: "/deleteAccount/terms",
    component: _90a2bb78,
    name: "deleteAccount-terms"
  }, {
    path: "/help/support",
    component: _4edcbfe7,
    name: "help-support"
  }, {
    path: "/products/cli",
    component: _004cff1e,
    name: "products-cli"
  }, {
    path: "/products/high-bandwidth",
    component: _b345e9c4,
    name: "products-high-bandwidth"
  }, {
    path: "/products/intranet",
    component: _dc0eac52,
    name: "products-intranet"
  }, {
    path: "/products/plugin",
    component: _1b53b66a,
    name: "products-plugin"
  }, {
    path: "/products/sdk",
    component: _568cbc90,
    name: "products-sdk"
  }, {
    path: "/products/speedtest-package",
    component: _3f8fdd4d,
    name: "products-speedtest-package"
  }, {
    path: "/products/speedtest-package-overcount",
    component: _495d533b,
    name: "products-speedtest-package-overcount"
  }, {
    path: "/smpro/payment",
    component: _2e43fe17,
    name: "smpro-payment"
  }, {
    path: "/wwzs/enterprise",
    component: _20e37ea1,
    name: "wwzs-enterprise"
  }, {
    path: "/products/cli/data",
    component: _0ee9be11,
    name: "products-cli-data"
  }, {
    path: "/products/cli/document",
    component: _d0d81602,
    name: "products-cli-document"
  }, {
    path: "/products/cli/download",
    component: _317e6dec,
    name: "products-cli-download"
  }, {
    path: "/products/high-bandwidth/data",
    component: _2d013211,
    name: "products-high-bandwidth-data"
  }, {
    path: "/products/high-bandwidth/document",
    component: _7cf868ff,
    name: "products-high-bandwidth-document"
  }, {
    path: "/products/intranet/document",
    component: _6fa423a6,
    name: "products-intranet-document"
  }, {
    path: "/products/plugin/data",
    component: _45061c84,
    name: "products-plugin-data"
  }, {
    path: "/products/plugin/document",
    component: _e3e9579c,
    name: "products-plugin-document"
  }, {
    path: "/products/sdk/data",
    component: _d446a892,
    name: "products-sdk-data"
  }, {
    path: "/products/sdk/document",
    component: _b4dbd7b6,
    name: "products-sdk-document"
  }, {
    path: "/products/sdk/download",
    component: _3f7c8d12,
    name: "products-sdk-download"
  }, {
    path: "/smpro/payment/success",
    component: _5084dd88,
    name: "smpro-payment-success"
  }, {
    path: "/products/cli/data/download",
    component: _b7a133ce,
    name: "products-cli-data-download"
  }, {
    path: "/products/high-bandwidth/data/download",
    component: _6f737219,
    name: "products-high-bandwidth-data-download"
  }, {
    path: "/products/plugin/data/download",
    component: _d8fae274,
    name: "products-plugin-data-download"
  }, {
    path: "/products/sdk/data/download",
    component: _67f6629a,
    name: "products-sdk-data-download"
  }, {
    path: "/",
    component: _79dc5948,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
